import { render } from "./ThemeDropdown.vue?vue&type=template&id=386ffb52"
import script from "./ThemeDropdown.vue?vue&type=script&lang=js"
export * from "./ThemeDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/doughcoteam.co.uk/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ThemeDropdown.vue"]])

export default __exports__